module.exports = require('./helpers/bundle-url').getBundleURL('aw0Im') + "logo.c5857b8b.svg";